import * as React from "react";

function SvgStateHover(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path className="state-hover_svg__st0" d="M9.2 15.8c-.3 0-.6-.2-.7-.5l-4.2-10c-.1-.3 0-.6.2-.8.2-.2.5-.3.8-.2l10 4.2c.3.1.5.4.5.7 0 .3-.2.6-.5.7l-4 1.4-1.4 4c-.1.2-.4.4-.7.5zM6.4 6.4l2.7 6.5.8-2.5c.1-.2.2-.4.5-.5l2.5-.8-6.5-2.7z" /><path className="state-hover_svg__st0" d="M3.7 7.6C2.7 7.2 2 6.2 2 5c0-1.6 1.3-3 3-3 1.2 0 2.2.7 2.7 1.7l1.7.7C9.1 2.2 7.3.5 5 .5 2.5.5.5 2.5.5 5c0 2.3 1.7 4.1 3.9 4.4l-.7-1.8z" /></svg>;
}

export default SvgStateHover;